import React from 'react';
import { SkillsGridProps } from '../interfaces';
import { SkillCard } from './SkillCard';

export const SkillsGrid = ({
  skills,
  currentPage,
  itemsPerPage,
  expandedSkills,
  searchQuery,
  getSubSkillsForSkill,
  onToggleExpand,
  onDeleteSkill,
  onDeleteSubSkill,
}: SkillsGridProps) => {
  if (skills.length === 0) {
    return (
      <div className='text-center py-16 text-gray-500 text-sm'>
        {searchQuery
          ? 'No skills found matching your search.'
          : 'No skills yet. Add one above!'}
      </div>
    );
  }

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 p-4'>
      {skills.map((skill, index) => {
        const subSkills = getSubSkillsForSkill(skill.value);
        const isExpanded = expandedSkills.has(skill.value);

        return (
          <SkillCard
              key={skill.value}
              skill={skill}
              index={index}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              subSkills={subSkills}
              isExpanded={isExpanded}
              onToggleExpand={onToggleExpand}
              onDeleteSkill={onDeleteSkill}
              onDeleteSubSkill={onDeleteSubSkill}
          />
        );
      })}
    </div>
  );
};
